import * as errors from '../errors';
import i18n from './i18n';

// Server error codes get sticky-lang copy for admin pages. smg/errors is
// shared with the brand sites, so it can't import admin i18n itself; this
// module can, and both IAP mains import it for its side effect so the two
// portals can't drift. Lazy so the language active at show time wins.
const bidCostLocked = () => i18n('bidCostLocked');
const blindShipLabelRewriteFailed = () => i18n('blindShipLabelRewriteFailed');
const carrierExcludedForOrder = () => i18n('carrierExcludedForOrder');
const uploadTransferTooSlow = () => i18n('uploadTransferTooSlow');
errors.RegisterCodeMessages({
    BID_COST_LOCKED: bidCostLocked,
    BLIND_SHIP_LABEL_REWRITE_FAILED: blindShipLabelRewriteFailed,
    CARRIER_EXCLUDED_FOR_ORDER: carrierExcludedForOrder,
    UPLOAD_TMP_COPY_STALLED: uploadTransferTooSlow,
    UPLOAD_TMP_COPY_TOO_SLOW: uploadTransferTooSlow,
});
